export const ROOT_SYSTEM_FIELDS_ID = 0;